// Threshold for showing the first and last 5 numbers. Since this function only
// returns the "middle" indexes, we use 4 for threshold.
const THRESHOLD = 4;

// This function returns the middle indexes for numbered pagination buttons.
// The first and the last page indexes are separately handled. This function
// is only concerned about the indexes in between first and the last.
export const getMiddlePageIndexes = (
    currentPageIndex: number,
    lastPageIndex: number,
): Array<number> => {
    let midPageIndexes: Array<number> = [];

    // Return an empty array if the indexes are invalid
    if (currentPageIndex < 0 || currentPageIndex > lastPageIndex) {
        return midPageIndexes;
    }

    if (currentPageIndex < THRESHOLD) {
        // We start from 1 to avoid including the first index, 0. This function
        // only returns the indexes in between 0 and the last page index.
        for (let i = 1; i <= THRESHOLD; i++) {
            midPageIndexes.push(i);
        }
    }
    if (currentPageIndex > lastPageIndex - THRESHOLD) {
        // We end at 1 to avoid including the last index, 0. This function only
        // returns the indexes in between 0 and the last page index.
        for (let i = THRESHOLD; i >= 1; i--) {
            midPageIndexes.push(lastPageIndex - i);
        }
    }
    if (midPageIndexes.length === 0) {
        midPageIndexes = [
            currentPageIndex - 1,
            currentPageIndex,
            currentPageIndex + 1,
        ];
    }
    // Filter out the indexes that are out of the range or duplicated.
    return Array.from(
        new Set(midPageIndexes.filter((i) => i > 0 && i < lastPageIndex)),
    );
};

export const getLastPageIndex = (
    totalCount: number,
    pageSize: number,
): number => {
    if (totalCount) {
        return Math.ceil(totalCount / pageSize) - 1;
    }
    return 0;
};
